import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      red: { red1 },
    },
  } = styleConfig;

  return {
    error: {
      color: red1,
      fontSize: 13,
      lineHeight: '14px',
    },
  };
};

export default styles;
